<div class="dash">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block" style="flex-direction: column;">
            <div class="row no-gutters">
                <div class="col-12">
                    <div style="padding-bottom: 0;">
                        <h2>Empresas</h2>
                        <p>Visualize, gerencie e inative empresas que
                            utilizam a
                            plataforma. Acesse os detalhes para ver papéis,
                            perfis e
                            usuários vinculados.</p>
                    </div>
                </div>

                <div class="col-12 d-flex justify-content-between align-items-center mt-5 px-0"
                    *ngIf="loading || data.length > 0 || hasFilters">
                    <div class="d-flex align-items-center">
                        <button type="button" class="sort-button mr-2"
                            (click)="refreshData()" [disabled]="loading">
                            <svg-icon
                                src="assets/images/icon-renew.svg"></svg-icon>
                            <span>Atualizar</span>
                        </button>
                    </div>

                    <div class="d-flex align-items-center">
                        <app-button
                            *ngIf="hasFilters && permissionObj.canFilter && !loading"
                            [danger]="true" [outline]="true"
                            class="add-button mr-2" (onClick)="resetForm()">
                            <svg-icon src="assets/images/icon-times.svg"
                                class="filter-clear-icon"></svg-icon>
                            Limpar filtros
                        </app-button>

                        <app-button [inverted]="true" class="add-button"
                            (onClick)="toggleFilterModal()" [disabled]="loading"
                            *ngIf="permissionObj.canFilter && (loading || data.length > 0 || hasFilters)">
                            <svg-icon
                                src="assets/images/icon_filter.svg"></svg-icon>
                            {{ hasFilters ? 'Editar filtros' : 'Filtrar
                            listagem' }}
                        </app-button>
                    </div>
                </div>

                <div class="col-12 mt-3 px-0"
                    *ngIf="hasFilters && appliedFilters.length > 0">
                    <div
                        class="d-flex flex-wrap align-items-center justify-content-end">
                        <app-filter-tag *ngFor="let filter of appliedFilters"
                            [label]="filter.label" [value]="filter.value">
                        </app-filter-tag>
                    </div>
                </div>
            </div>
        </div>

        <div class="dash-card-body padding-container pt-0">
            <ng-container *ngIf="loading">
                <table #table class="bordered">
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; gap: 8px;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '200px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '14px',
                                        width: '150px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; gap: 8px;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '150px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '14px',
                                        width: '120px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '150px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; gap: 8px;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '120px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '14px',
                                        width: '100px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '24px',
                                    width: '70px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <div
                                    style="display: flex; gap: 8px; justify-content: flex-end;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '16px',
                                        marginBottom:'0',
                                        borderRadius: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '16px',
                                        marginBottom:'0',
                                        borderRadius: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered" *ngIf="!loading && data.length > 0">
                <thead>
                    <tr>
                        <th>Razão Social</th>
                        <th>Papel</th>
                        <th>Perfis de acesso</th>
                        <th>Atualizada em</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of data">
                        <td>
                            <div class="dash-card-item-content"
                                *ngIf="item.company">
                                <div class="dash-card-item-content-title">
                                    {{item.company}}
                                </div>
                                <div class="dash-card-item-content-subtitle"
                                    *ngIf="item.document_number">
                                    {{formatCnpj(item.document_number)}}
                                </div>
                            </div>
                            <span *ngIf="!item.company">-</span>
                        </td>

                        <td>
                            <div class="dash-card-item-content"
                                *ngIf="item.role">
                                <div class="dash-card-item-content-title">
                                    {{displayRole(item.role).main}}
                                </div>
                                <div class="dash-card-item-content-subtitle"
                                    *ngIf="displayRole(item.role).subtitle">
                                    {{displayRole(item.role).subtitle}}
                                </div>
                            </div>
                            <span *ngIf="!item.role">-</span>
                        </td>

                        <td>
                            {{renderProfiles(item.users_type) || '-'}}
                        </td>

                        <td>
                            <div class="dash-card-item-content"
                                *ngIf="item.updated_at">
                                <div class="dash-card-item-content-title">
                                    {{displayDateTime(item.updated_at).date}}
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    {{displayDateTime(item.updated_at).time}}
                                </div>
                            </div>
                            <span *ngIf="!item.updated_at">-</span>
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="isStatusInactive(item.status)">
                                {{getStatusDisplay(item.status)}}</div>
                        </td>

                        <td>
                            <div class="dash-card-item-buttons"
                                [class.single-button]="!(isOwner && !isCurrentUserCompany(item.register_uuid))">
                                <app-tooltip text="Visualizar" position="top">
                                    <button class="dash-item-button"
                                        (click)="redirectToDetails(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"></svg-icon>
                                    </button>
                                </app-tooltip>

                                <app-tooltip
                                    [text]="item.status === 'active' ? 'Inativar' : 'Ativar'"
                                    position="top"
                                    *ngIf="isOwner && !isCurrentUserCompany(item.register_uuid)">
                                    <button class="dash-item-button"
                                        (click)="toggleCompanyStatus(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-ban.svg"
                                            *ngIf="item.status === 'active'"></svg-icon>
                                        <svg-icon
                                            src="assets/images/icon-check-filled.svg"
                                            fill="var(--success)"
                                            *ngIf="item.status === 'inactive'"></svg-icon>
                                    </button>
                                </app-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <ng-container *ngIf="!loading && data.length === 0">
                <app-empty-content [isVisible]="true" [large]="true"
                    [title]="hasFilters ? 'Nenhum resultado encontrado' : 'Não há nenhuma empresa para exibir'"
                    [description]="hasFilters ? 'Não encontramos nenhuma empresa com os filtros aplicados. Tente ajustar os filtros ou limpar para ver todas as empresas.' : 'Não há empresas para serem exibidos no momento'"
                    icon="/assets/images/figure_3d_search.png">
                </app-empty-content>
            </ng-container>
        </div>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" *ngIf="data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData($event)"
            [dashPagination]="true">
        </app-pagination>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                placeholder="Digite" label="Empresa">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="document"
                label="CNPJ" documentType="cnpj" [skipValidation]="true">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-6">
            <app-select [items]="roleOptions" [group]="filterForm"
                controlName="role" placeholder="Selecione" [multiple]="true"
                label="Papel">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-6">
            <app-select [items]="statusOptions" [group]="filterForm"
                controlName="status" placeholder="Selecione" label="Status">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-6">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-6">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>

<!-- Modal para adicionar perfis de acesso -->
<app-side-modal [active]="showAddProfilesModal"
    (onClose)="closeAddProfilesModal()" [title]="'Adicionar perfis de acesso'">
    <div class="row" *ngIf="selectedCompany">
        <div class="col-12">
            <!-- Informações da empresa -->
            <div
                style="background-color: var(--main-alternative-lighter); padding: 16px; border-radius: 8px; margin-bottom: 24px;">
                <div style="margin-bottom: 8px;">
                    <strong
                        style="color: var(--black); font-size: var(--font-md);">Empresa:</strong>
                    <span
                        style="color: var(--black); margin-left: 8px;">{{selectedCompany.company}}</span>
                </div>
                <div>
                    <span
                        style="color: var(--black);">{{formatCnpj(selectedCompany.document_number)}}</span>
                </div>
            </div>

            <p
                style="margin-bottom: 20px; color: var(--black); line-height: 1.6;">
                Esta empresa <strong>não possui perfil de acesso</strong> e
                precisa ter pelo menos um perfil de acesso para ser ativada.
                Selecione os perfis de acesso abaixo:
            </p>

            <app-select [items]="profileOptions" [group]="profilesForm"
                controlName="profiles" [multiple]="true"
                label="Perfis de acesso" [disabled]="loadingProfiles">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 d-flex justify-content-between">
            <app-button [phantom]="true" (onClick)="closeAddProfilesModal()">
                Cancelar
            </app-button>

            <app-button (onClick)="addProfilesToCompany()"
                [disabled]="!profilesForm.get('profiles')?.value || profilesForm.get('profiles')?.value?.length === 0 || loadingProfiles">
                Adicionar e ativar
            </app-button>
        </div>
    </div>
</app-side-modal>